import React from "react"

type TextareaSize = "sm" | "md" | "lg"

// styles
// https://www.figma.com/file/mUteT8dtwr6r8A1BhA34AC/Cryptobots-Web?node-id=1424%3A9628
export type TextareaProps = {
  placeholder?: string
  label?: string
  labelClassName?: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  size?: TextareaSize
  className?: string
  bgColor?: string
  borderColorClass?: string
  heightClass?: string
  max?: number
  additionInputClasses?: string
}

export function Textarea({
  value = "",
  onChange,
  disabled = false,
  placeholder = "",
  size = "md",
  className = "",
  bgColor = "bg-transparent",
  additionInputClasses = "",
  max,
  label,
  heightClass = "h-[7.5rem]",
  labelClassName = "",
  borderColorClass,
}: TextareaProps): React.ReactElement {
  const classNames = [
    `
        inline-flex
        rounded-box
        ${bgColor}
        border border ${borderColorClass || "border-white/20"}
        text-[1rem] font-medium leading-[1.75rem] text-white/80

        focus:outline-none
        focus:border-white
        focus:text-white
        focus-visible:outline-none
        focus-visible:text-white
        focus-visible:border-white

        disabled:opacity-50
        disabled:select-none 
        disabled:cursor-not-allowed
        h-full
        resize-none
    `,
    additionInputClasses,
  ]
  classNames.push(getInputTextSizeClasses(size))

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    value = event.target.value
    onChange(event.target.value)
  }

  return (
    <label className={["inline-flex flex-col", heightClass, className].join(" ")}>
      {label &&
        (labelClassName ? (
          <span className={labelClassName}>{label}</span>
        ) : (
          <span className="text-white/80 mb-[4px] text-[14px] leading-[20px]">{label}</span>
        ))}
      <textarea
        className={classNames.join(" ")}
        disabled={disabled}
        value={value}
        maxLength={max}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </label>
  )
}

const getInputTextSizeClasses = (size: TextareaSize) => {
  switch (size) {
    case "sm":
      return "py-1"
    case "md":
      return "py-2.5 px-4"
    case "lg":
      return "px-4 py-4 text-6"
    default:
      return ""
  }
}
